import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import { FaDiscord } from 'react-icons/fa6';

import Header from '@/common/header';
import TrialHero from '@/components/trial/hero';
import PromoSection from '@/components/trial/promo-section';

import { Features } from '../features';
import { Footer } from '../footer';
import type { DefaultTrialProps } from '../trial-layout-switcher';

export default function DefaultCustomTrialDiscord({ daysTrial = 3, trialConfigId }: DefaultTrialProps) {
  const { t } = useTranslation('components/trial/default-custom-trial-discord');

  return (
    <>
      <Header variant='secondary' />
      <div className='mb-16 flex flex-col gap-20 px-5'>
        <TrialHero daysTrial={daysTrial} pathVideoWithOutNoPing='/assets/video/cod-sem-noping.mp4' pathVideoWithNoPing='/assets/video/cod-com-noping.mp4' customTrial={trialConfigId} isDiscordTrial />
        <section className='mx-auto w-full max-w-[1400px]'>
          <div className='mx-auto grid w-full grid-cols-1 gap-3 sm:grid-cols-2 ipad:grid-cols-3'>
            <div className='mx-auto flex max-h-[400px] w-full max-w-[431px] flex-col justify-between overflow-hidden rounded-xl'>
              <div className="h-[235px] bg-[url('/assets/images/trial/cards/1.webp')] bg-no-repeat" />
              <div className='roundex-xl relative z-20 h-[216px] space-y-2 bg-[#0E1113] px-8 py-5 text-white'>
                <h3 className='text-[1.5rem] font-bold uppercase leading-[140%]'>discord</h3>
                <p className='mt-0.5 font-medium leading-[140%]'>
                  <Trans components={{ span: <span className='text-[#93FF18]' /> }}>{t('cards.1.description')}</Trans>
                </p>
              </div>
            </div>

            <div className='mx-auto flex max-h-[400px] w-full max-w-[431px] flex-col justify-between overflow-hidden rounded-xl'>
              <div className="h-[235px] bg-[url('/assets/images/trial/cards/2.webp')] bg-no-repeat" />
              <div className='roundex-xl relative z-20 h-[216px] space-y-2 bg-[#0E1113] px-8 py-5 text-white'>
                <h3 className='text-[1.5rem] font-bold uppercase leading-[140%]'>chrome</h3>
                <p className='mt-0.5 font-medium leading-[140%]'>
                  <Trans components={{ span: <span className='text-[#93FF18]' /> }}>{t('cards.2.description')}</Trans>
                </p>
              </div>
            </div>

            <div className='mx-auto flex max-h-[400px] w-full max-w-[431px] flex-col justify-between overflow-hidden rounded-xl'>
              <div className="h-[235px] bg-[url('/assets/images/trial/cards/3.webp')] bg-no-repeat" />
              <div className='roundex-xl relative z-20 h-[216px] space-y-2 bg-[#0E1113] px-8 py-5 text-white'>
                <h3 className='text-[1.5rem] font-bold uppercase leading-[140%]'>opera</h3>
                <p className='mt-0.5 font-medium leading-[140%]'>
                  <Trans components={{ span: <span className='text-[#93FF18]' /> }}>{t('cards.3.description')}</Trans>
                </p>
              </div>
            </div>

            <div className='mx-auto flex max-h-[400px] w-full max-w-[431px] flex-col justify-between overflow-hidden rounded-xl'>
              <div className="h-[235px] bg-[url('/assets/images/trial/cards/5.webp')] bg-no-repeat" />
              <div className='roundex-xl relative z-20 h-[216px] space-y-2 bg-[#0E1113] px-8 py-5 text-white'>
                <h3 className='text-[1.5rem] font-bold uppercase leading-[140%]'>counter strike 2</h3>
                <p className='mt-0.5 font-medium leading-[140%]'>
                  <Trans components={{ span: <span className='text-[#93FF18]' /> }}>{t('cards.4.description')}</Trans>
                </p>
              </div>
            </div>

            <div className='mx-auto flex max-h-[400px] w-full max-w-[431px] flex-col justify-between overflow-hidden rounded-xl'>
              <div className="h-[235px] bg-[url('/assets/images/trial/cards/4.webp')] bg-no-repeat" />
              <div className='roundex-xl relative z-20 h-[216px] space-y-2 bg-[#0E1113] px-8 py-5 text-white'>
                <h3 className='text-[1.5rem] font-bold uppercase leading-[140%]'>fortnite</h3>
                <p className='mt-0.5 font-medium leading-[140%]'>
                  <Trans components={{ span: <span className='text-[#93FF18]' /> }}>{t('cards.5.description')}</Trans>
                </p>
              </div>
            </div>

            <div className='mx-auto flex max-h-[400px] w-full max-w-[431px] flex-col justify-between overflow-hidden rounded-xl'>
              <div className="h-[235px] bg-[url('/assets/images/trial/cards/6.webp')] bg-no-repeat" />
              <div className='roundex-xl relative z-20 h-[216px] space-y-2 bg-[#0E1113] px-8 py-5 text-white'>
                <h3 className='text-[1.5rem] font-bold uppercase leading-[140%]'>valorant</h3>
                <p className='mt-0.5 font-medium leading-[140%]'>
                  <Trans components={{ span: <span className='text-[#93FF18]' /> }}>{t('cards.6.description')}</Trans>
                </p>
              </div>
            </div>
          </div>
        </section>
        <PromoSection pathImage='/assets/images/trial/trial-ru.webp' customTrial={trialConfigId} isDiscordTrial daysTrial={daysTrial} />
        <Features />

        <section className="mx-auto mt-10 flex h-80 w-full max-w-[1400px] flex-col items-center justify-center rounded-xl bg-[url('/assets/images/trial/bg-second.webp')] bg-cover bg-center bg-no-repeat">
          <div className='flex w-full max-w-lg flex-col items-center justify-center gap-4 px-5'>
            <h3 className='text-[1.5rem] font-bold leading-7 text-white'>
              <Trans values={{ days: daysTrial }} components={{ span: <span className='text-[#93FF18]' /> }}>
                {t('last_section.title')}
              </Trans>
            </h3>

            <Link className='click_days_free_discord mt-5 flex w-72 items-center justify-center gap-4 rounded-xl bg-[#5865F2] py-4 text-center text-sm font-bold uppercase text-white transition-opacity hover:opacity-80 mobile:px-10' href={process.env.NEXT_PUBLIC_DISCORD_URL_TRIAL ?? ''} target='_blank' rel='noopener noreferrer'>
              <FaDiscord size={24} />
              <Trans values={{ days: daysTrial }}>{t('last_section.button')}</Trans>
            </Link>
            <p className='text-base font-normal text-green-300'>{t('last_section.no_credit_card')}</p>
          </div>
        </section>
      </div>
      <Footer variant='primary' text={t('footer', { year: new Date().getFullYear() })} />
    </>
  );
}
